// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogCategoryPicker from "./CatalogCategoryPicker.res.js";

function keyExtractor(row) {
  return row.shopId;
}

let Row = {
  keyExtractor: keyExtractor
};

function tableColumns(everyShopsDuplicable, hideCategory, onRequestCategoryUpdate) {
  return [
    {
      key: "shop-catalog",
      name: I18n.t("Shop catalog"),
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: param.data.shopName,
        variation: param.disabled ? "subdued" : "neutral"
      })
    },
    {
      key: "product-category",
      name: I18n.t("Category"),
      layout: {
        hidden: hideCategory
      },
      render: param => {
        let match = param.data;
        let categoryName = match.categoryName;
        let shopId = match.shopId;
        let onChange = category => {
          if (typeof category !== "object") {
            return onRequestCategoryUpdate({
              id: undefined,
              name: I18n.t("Not classified"),
              shopId: shopId
            });
          }
          let match = category._0;
          onRequestCategoryUpdate({
            id: match.id,
            name: match.formattedName,
            shopId: shopId
          });
        };
        if (param.disabled) {
          return JsxRuntime.jsx(TextStyle.make, {
            children: Stdlib_Option.getOr(categoryName, "—"),
            variation: "subdued"
          });
        } else {
          return JsxRuntime.jsx(CatalogCategoryPicker.make, {
            variation: Stdlib_Option.isSome(categoryName) ? "important" : "neutral",
            value: Stdlib_Option.getOr(categoryName, I18n.t("Add a category")),
            shopId: shopId,
            onChange: onChange
          });
        }
      }
    },
    {
      key: "more-information",
      name: I18n.t("Additional information"),
      layout: {
        hidden: everyShopsDuplicable
      },
      render: param => {
        let note = param.data.note;
        if (note !== undefined) {
          return JsxRuntime.jsx(TextStyle.make, {
            children: note,
            variation: param.disabled ? "subdued" : "neutral"
          });
        } else {
          return null;
        }
      }
    }
  ];
}

let make = TableView.make;

export {
  Row,
  tableColumns,
  make,
}
/* I18n Not a pure module */
